export default "__VITE_ASSET__DbsCeSAo__"